
import { ColumnBib, ColumnName, ColumnNoc, ColumnExpander, ColumnResult } from "components/common/TableColumns"
import Label from "components/general/Label"
import SportCode from 'components/common/SportCode'
import { findArray, RscFromStore } from 'helpers/utils'
import { getRscObject } from 'helpers/rsc';

export function TableColumnsQualification() {

    return (
        [
            ColumnBib({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            {
                //Header: <Label data={"HeaderTeam"} />,
                accessor: 'sortOrder',
                className: "text-start",
                headerClassName: "w-5 text-start",
                //disableSortBy: disableSort, //habilita poder ordenar
                id: 'HasSecondValue',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let second = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? '(2VT)' : ''
                    return (<span>{second}</span>)
                }
            },
            ColumnResultLocal({ label: "Score", id: "Result" }),
            ColumnExpander({ type: 'alwaysTrue', erCode: "SCORE" })
        ]
    )
}

export function TableColumnsFinal() {

    return (
        [
            ColumnBib({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true, label: "HeaderName" }),
            {
                //Header: <Label data={"HeaderTeam"} />,
                accessor: 'sortOrder',
                className: "text-start",
                headerClassName: "w-5 text-start",
                //disableSortBy: disableSort, //habilita poder ordenar
                id: 'HasSecondValue',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let second = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? '(2VT)' : ''
                    return (<span>{second}</span>)
                }
            },
            ColumnResultAth({ label: "Score", id: "ResultAth" }),
            ColumnResult({ label: "HeaderTeamTotal" }),
            ColumnExpander({ type: 'alwaysTrue', erCode: "SCORE" })
        ]
    )
}

function ColumnResultLocal({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult',
    id = 'Result'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: id,

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let row = props.cell.row.original
                let resultIrm = (row.resultIrm)
                let irmValue = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
                let resultData = '';
                let resultInquire1;
                let resultInquire2;


                const posFirtsColumn = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: [1] }) ? true : false;
                resultInquire1 = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['INQUIRY'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
                resultInquire2 = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['INQUIRY'], ...(posFirtsColumn && { er_pos: ["2"] }) })?.er_value


                if (row.resultData) {
                    resultData = row.resultData
                } else {
                    resultData = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['SCORE'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
                }

                let resp;
                if (row.resultType !== 'IRM') {
                    resp = resultData;
                } else {
                    resp = irmValue;
                }

                if (resultInquire1 || resultInquire2) {
                    //let code = resultInquire1 ? resultInquire1 : resultInquire2
                    //resp = <><SportCode discipline={"GAR"} entity='@Inquiry' code={code} />{resp}</>;
                    resp = "*" + resp;
                }

                return (resp)
            },
        }
    )
}

function ColumnResultAth({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult',
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'resultDataAth',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'ResultAth',

            Cell: (props) => {
                let row = props.cell.row.original
                //let resultIrm = (row.resultIrm)
                let resultData = '';
                let resultInquire1;
                let resultInquire2;

                const posFirtsColumn = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: [1] }) ? true : false;
                resultInquire1 = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['INQUIRY'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
                resultInquire2 = findArray(row?.extendedResults, { er_type: ['ER'], er_code: ['INQUIRY'], ...(posFirtsColumn && { er_pos: ["2"] }) })?.er_value
                resultData = row.resultDataAth

                let resp;
                if (row.resultType !== 'IRM') {
                    resp = resultData;
                }

                if (resultInquire1 || resultInquire2) {
                    //let code = resultInquire1 ? resultInquire1 : resultInquire2
                    //resp = <><SportCode discipline={"GAR"} entity='@Inquiry' code={code} />{resp}</>;
                    resp = "*" + resp;
                }


                return (
                    (row.resultType !== 'IRM')
                        ? resp
                        : ''
                )
            },
        }
    )
}